/**
 * QUEBRAR UMA LINHA EM PALAVRAS, SEM PERDER NADA NO CAMINHO.
 *
 * Isto é um módulo à parte de `palavras-que-surgem.tsx` por um motivo só: é aqui que se perde
 * acento, espaço duplo e pontuação — e o título da home é a primeira coisa que alguém lê do
 * produto. Um `split(" ")` ingênuo devolve entradas vazias em espaço duplo, e cada entrada vazia
 * vira um `<span>` que ocupa lugar e desloca a frase.
 *
 * A regra é a que dá para cobrar: **juntar de volta tem que devolver a linha original.**
 */

/**
 * As palavras de uma linha, na ordem, com o espaço colado no fim de cada uma.
 *
 * O espaço vai DENTRO da palavra e não entre os `<span>` porque JSX come o espaço entre elementos
 * irmãos escritos em linhas separadas. Colado, ele sobrevive — e `white-space: pre-wrap` no CSS o
 * preserva na renderização.
 *
 * A última palavra não leva espaço: um espaço no fim da linha empurraria a centralização por meio
 * caractere, o que é exatamente o tipo de erro que ninguém acha olhando.
 */
export function palavrasDaLinha(linha: string): string[] {
  // `match` e não `split`: o `split` com captura devolve entradas vazias nas pontas, e cada uma
  // delas viraria um `<span>` vazio no DOM.
  const achadas = linha.match(/\S+\s*/g);
  if (!achadas) return [];
  return achadas.map((p, i) => (i === achadas.length - 1 ? p.trimEnd() : p));
}

/** A volta, que é o que o teste cobra. Não é usada em produção — é a definição de "não perdeu nada". */
export function juntarPalavras(palavras: string[]): string {
  return palavras.join("");
}
